require('dom-slider');

const { slideUp, slideDown } = window.domSlider;

const loadMoreButtons = document.querySelectorAll(
	'.block-cards__load-more-button'
);

const initializeBlock = (loadMoreButton) => {
	const block = loadMoreButton.closest('.block-cards');

	if (block && block.hasAttribute('data-visible-cards')) {
		const grid = block.querySelector('.block-cards__grid');
		const cards = block.querySelectorAll(`.block-card`);

		if (grid && cards.length > 0) {
			const visibleCards = block.getAttribute('data-visible-cards');
			const hiddenCardWrapper = document.createElement('div');
			const visibleCardWrapper = document.createElement('div');
			hiddenCardWrapper.classList.add('block-cards__hidden-card-wrapper');
			visibleCardWrapper.classList.add(
				'block-cards__visible-card-wrapper'
			);

			cards.forEach((card, index) => {
				if (index >= visibleCards) {
					hiddenCardWrapper.appendChild(card);
				} else {
					visibleCardWrapper.appendChild(card);
				}
			});

			grid.appendChild(visibleCardWrapper);
			grid.appendChild(hiddenCardWrapper);

			slideUp({
				element: hiddenCardWrapper,
				slideSpeed: 0,
			});
		}
	}
};

const loadMore = (e) => {
	e.preventDefault();

	const block = e.currentTarget.closest('.block-cards');

	if (block) {
		const cardWrapper = block.querySelector(
			'.block-cards__hidden-card-wrapper'
		);

		if (cardWrapper) {
			slideDown({
				element: cardWrapper,
				slideSpeed: 400,
				easing: 'ease-in-out',
			});

			e.currentTarget.parentElement.classList.add('inactive');
		}
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		if (loadMoreButtons.length > 0) {
			loadMoreButtons.forEach((loadMoreButton) => {
				loadMoreButton.addEventListener('click', loadMore);

				initializeBlock(loadMoreButton);
			});
		}
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
